import { Implant } from "./implant";
import { Extraction } from "./extraction";
import { WisdomToothExtraction } from "./wisdom-tooth-extraction";
import { SinusLift } from "./sinus-lift";
import { EdentulousRehab } from "./edentulous-rehab";
import { RemoveImplant } from "./remove-implant";
import { SurgicalGuide } from "./surgical-guide";

export const treatments = [
  Implant,
  Extraction,
  WisdomToothExtraction,
  SinusLift,
  EdentulousRehab,
  RemoveImplant,
  SurgicalGuide,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/implants/index.ts